import { stringify } from 'querystring';
import { useEffect, useRef } from 'react';
import { parseSearch } from '@peloton/redux';
import { isLibrary } from '@engage/classes';
import { isApiOverridden, toApiEnv } from '@members/env';
import { toModalOpenRecord } from '@members/modal';
import { CLASS_DETAILS_MODAL_NAME, CLASS_ID_PARAM, SOURCE_PARAM } from './constants';
import type { OnDemandModalViewType, ClassInLibrary } from './types';

export const toOnDemandModalQuery = (
  classId: string,
  source?: string,
  location: Location = window.location,
) => {
  const queryParams = {
    ...parseSearch(location),
    ...toModalOpenRecord(CLASS_DETAILS_MODAL_NAME),
    [CLASS_ID_PARAM]: classId,
  };
  if (isApiOverridden(location.hostname)) {
    queryParams['api-env'] = toApiEnv(location.hostname);
  }

  if (source && source !== '') {
    queryParams[SOURCE_PARAM] = source;
  }

  return `?${stringify(queryParams)}`;
};

export const isInLibrary = (klass: any): klass is ClassInLibrary =>
  isLibrary(klass) && klass.isInLibrary;

// Compares the current view with the targt view in the on-demand-modal
// If they are the same, it scrolls into the target ref element
export const useScrollIntoView = (
  lastView: OnDemandModalViewType,
  targetView: OnDemandModalViewType,
) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && lastView === targetView) {
      setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 400);
    }
  }, [lastView, targetView]);

  return ref;
};
